import { gql, useMutation } from '@apollo/client';
import { GET_PENDING_ELECTIONS } from './usePendingElections';

const CLAIM_PENDING_ELECTION = gql`
  mutation ClaimPendingElection($id: ID!) {
    election: claimPendingElection(pendingElectionId: $id) {
      id
    }
  }
`;

export default function useClaimElection({ onCompleted = () => {}, onError = () => {}, pendingElectionId }) {
  const [claim, { loading, error }] = useMutation(CLAIM_PENDING_ELECTION, {
    variables: { id: pendingElectionId },
    onCompleted,
    refetchQueries: [{ query: GET_PENDING_ELECTIONS }],
    onError
  });

  return {
    claim,
    loading,
    error
  };
}
